import Cookies from 'js-cookie';

export function getStorefront() {
    try {
        const storefront = Cookies.get('kotn-storefront');
        if (storefront) {
            return storefront;
        }
        return 'kotn-ss15'; 
    } catch (err) {
        return 'kotn-ss15';
    }
}

export function setStorefront(storefront) {
    try {
        Cookies.set('kotn-storefront', storefront, { expires: 60 });
    } catch (err) {
        console.error('Error setting storefront in cookies:', err);
    }
}

export function resolveStorefrontToken() {
    const storefront = getStorefront();
    if ((storefront === 'kotn-uk')) {
        return {
            storefront_uri: process.env.NEXT_PUBLIC_SHOPIFY_STORE_URI_UK,
            access_token: process.env.NEXT_PUBLIC_SHOPIFY_STOREFRONT_TOKEN_UK
        }
    }
    return {
        storefront_uri: process.env.NEXT_PUBLIC_SHOPIFY_STORE_URI,
        access_token: process.env.NEXT_PUBLIC_SHOPIFY_STOREFRONT_TOKEN
    }
}
